/**
 * JKK東京の住宅種別。
 *
 * 公社一般賃貸住宅と東京都施行型都民住宅は、募集システムも申込条件も別物なので
 * 画面上でも区別する。料金の呼び名まで違う（家賃/敷金 と 使用料/保証金）ため、
 * ラベルはここに集約して表記を揃える。
 *
 * 都民住宅の danchi.id は seed 時に `jkk_to_{ページ番号}`（例: jkk_to_64）で固定している。
 * 本番DBに専用カラムを足さず、このプレフィックスで判定する。
 */

export const TOMIN = "tomin";
export const TOMIN_ID_PREFIX = "jkk_to_";

/** danchi.id から種別を取る。都民住宅以外は null（バッジを出さない） */
export function housingTypeFromId(id?: string | null): typeof TOMIN | null {
  return id?.startsWith(TOMIN_ID_PREFIX) ? TOMIN : null;
}

/**
 * 都民住宅かどうか。
 * "tomin" そのもの、または `jkk_to_` で始まる danchi.id を受け付ける。
 */
export function isTomin(housingTypeOrId?: string | null): boolean {
  if (!housingTypeOrId) return false;
  return housingTypeOrId === TOMIN || housingTypeOrId.startsWith(TOMIN_ID_PREFIX);
}

/** バッジなどに出す種別名 */
export function housingTypeLabel(housingTypeOrId?: string | null): string | null {
  return isTomin(housingTypeOrId) ? "都民住宅" : null;
}

/** 月額の呼び名。都民住宅は「家賃」ではなく「使用料」 */
export function rentLabel(housingTypeOrId?: string | null): string {
  return isTomin(housingTypeOrId) ? "使用料" : "家賃";
}

/** 入居時一時金の呼び名。都民住宅は「敷金」ではなく「保証金」 */
export function depositLabel(housingTypeOrId?: string | null): string {
  return isTomin(housingTypeOrId) ? "保証金" : "敷金";
}
